var styles = {"actions":"styles_actions__w4IUZ","wrap":"styles_wrap__XME2u","allowShrink":"styles_allow-shrink__w2Psk","noSpacing":"styles_no-spacing__eSkFd","compactSpacing":"styles_compact-spacing__6Zw5b","comfortableSpacing":"styles_comfortable-spacing__1nk7z","looseSpacing":"styles_loose-spacing__iR4Go"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
